import { useSidebar } from '@/components/ui/sidebar';
import MonitoringFilter from '@/features/monitoring/components/monitoring-filter/MonitoringFilter';
import { useMonitoringStore } from '@/features/monitoring/store/useMonitoringStore';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { SidebarFarmers } from './sidebar/Sidebar';

export const FarmersWrapper: FC = () => {
  const { open } = useSidebar();
  const { farmerData, farmerLoading } = useMonitoringStore();

  return (
    <div className="w-full h-full flex">
      <SidebarFarmers
        items={farmerData.content || []}
        isLoading={farmerLoading}
        totalPages={farmerData.totalPages || 1}
        totalElements={farmerData.totalElements}
      />
      <div className="w-full flex flex-col bg-gray-100 h-full overflow-auto">
        <MonitoringFilter />
        <div className="flex-1 overflow-y-auto flex flex-col gap-4 ">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
